import url from '@/utils/config';
import AtImageLink from '../atoms/AtImageLink';

/** 属性定義 */
type Props = {
  className?: string;
};

/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const OrHeaderAreaNoLogin = ({
  className
}: Props) => {
  return <header className={`orheaderareanologin ${className}`}>
      <p className='headTtl'>
        <AtImageLink href='/account/login' imgSrc={url('/images/logo_manoma.svg')} />
      </p>
    </header>;
};
/** 初期値の設定 */
OrHeaderAreaNoLogin.defaultProps = {
  className: ''
};
export default OrHeaderAreaNoLogin;